import { User } from './../models/user';
import { Authuser } from './../models/authuser';
import { Injectable } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';

import { Router } from "@angular/router";
import * as firebase from 'firebase/app';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/switchMap';
import * as _ from 'lodash';


@Injectable()
export class AuthService {

  public authStatus: User = null;
  public displayUser: User;
  public userRoles:  Array<string>;
  authUser: Authuser;
  isSuperAdmin: boolean;
  userInfo: FirebaseObjectObservable<any>;

  user: BehaviorSubject<Authuser> = new BehaviorSubject(null)

  constructor(public afAuth: AngularFireAuth,
              private db: AngularFireDatabase,
              private router:Router) {

        this.afAuth.authState.subscribe( auth => {
          if (auth) { 
            if (! this.displayUser ) {
            this.getUserDetails().subscribe(current =>{
              this.displayUser = current;
              this.authStatus = current;
              console.log('display user step 1', this.displayUser)
              this.userRoles = _.keys(_.get(current,'roles'))
              this.isSuperAdmin = !_.isEmpty(_.intersection(this.userRoles ,['superadmin']));
              return (this.displayUser.isSecretSet);
            })
          }
        }
        });
  }

  getUserDetails(){
    return this.db.object('/users/'+ this.afAuth.auth.currentUser.uid) as FirebaseObjectObservable<User>;
  }

  private matchingRole(allowedRoles):boolean {
    return !_.isEmpty(_.intersection(allowedRoles, this.userRoles));
}


get canRead():boolean {
  const allowed = ['superadmin','admin','author','reader']
  return this.matchingRole(allowed)
}

get canEdit():boolean {
  const allowed = ['superadmin','admin']
  return this.matchingRole(allowed)
}
get canDelete():boolean {
  const allowed = ['superadmin','admin']
  return this.matchingRole(allowed)
}
  // Returns true if user is logged in
get authenticated(): boolean {
    return this.authStatus !== null;
}



  // Returns current user data
  get currentUser(): any {
    return this.authenticated ? this.authStatus : null;
  }


  // Returns current user data
  get isDoneRegistering(): any {
    if (this.authStatus ) {
    return this.authStatus.isSecretSet ? true : false;
  } else { return false }

  }


  getAuth(){
    //this.currentUserProfile;
    return this.afAuth.authState.map(auth => auth);
  }

  get currentUserProfile(){
    return this.authUser
  }
  // Returns
  get currentUserObservable(): any {
    return this.afAuth.authState
  }

  // Returns current user UID
  get currentUserId(): string {
    return this.authenticated ? this.authStatus.uid : '';
  }

  // Anonymous User
  get currentUserAnonymous(): boolean {
    return this.authenticated ? this.authStatus.isAnonymous : false
  }

  // Returns current user display name or Guest
  get currentUserDisplayName(): string {

    if (!this.authStatus) {
      return 'Guest'
    }
    else if (this.currentUserAnonymous) {
      return 'Anonymous'
    }
    else {
      return this.authStatus['displayName'] ;//|| this.authState['name']
    }
  }

  //// Social Auth ////

   githubLogin() {
    const provider = new firebase.auth.GithubAuthProvider()
    return this.socialSignIn(provider);
  }

  googleLogin() {
    const provider = new firebase.auth.GoogleAuthProvider()
    return this.socialSignIn(provider);
  }

  facebookLogin() {
    const provider = new firebase.auth.FacebookAuthProvider()
    return this.socialSignIn(provider);
  }

  twitterLogin(){
    const provider = new firebase.auth.TwitterAuthProvider()
    return this.socialSignIn(provider);
  }

  private socialSignIn(provider) {
    return this.afAuth.auth.signInWithPopup(provider)
      .then((credential) =>  {
          this.authStatus = credential.user
          //console.log(credential)
          this.updateUserData(credential.user)

      })
      .catch(error => console.log(error));
  }

  //// Anonymous Auth ////

  anonymousLogin() {
    return this.afAuth.auth.signInAnonymously()
    .then((user) => {
      this.authStatus = user
    })
    .catch(error => console.log(error));
  }

  //// Email/Password Auth ////

emailSignUp(email:string, password:string,displayName:string,phone:string) {

  return new Promise((resolve,reject) => {
    this.afAuth.auth.createUserWithEmailAndPassword(email, password)
      .then(userData => {
        this.authStatus = userData
        let dat = { uid: this.authStatus.uid, email: this.authStatus.email , displayName: displayName, phone: phone, photoURL: this.authStatus.photoURL }
        let uI = new User(dat);
        this.updateUserData(dat)
        this.user.next(uI)
        resolve(this.authStatus)
      },
        err => reject(err)
        );
  });
  }

emailLogin(email:string, password:string) {

  return new Promise((resolve,reject) => {
      this.afAuth.auth.signInWithEmailAndPassword(email,password)
        .then(userData => {
          this.authStatus = userData
     //     this.updateUserData(userData)
          this.user.next(userData)
          resolve(userData)
        },
          err => reject(err)
          );
    });
  }

  // Sends email allowing user to reset password
  resetPassword(email: string) {
    const fbAuth = firebase.auth();
    return fbAuth.sendPasswordResetEmail(email)
      .then(() => console.log("email sent"))
      .catch((error) => console.log(error))
  }

  /////  send email ////
  sendResetEmail(email:string){
    return new Promise((resolve,reject) => {
     this.afAuth.auth.sendPasswordResetEmail(email)
       .then(userData => resolve(userData),
         err => reject(err));
   });

 }

clear(): void {
    this.displayUser = null;
    this.authStatus = null;
    this.userRoles = null;
    this.isSuperAdmin = false;
 }
  //// Sign Out ////
logout(): void {
    this.clear();
    localStorage.clear();
    this.afAuth.auth.signOut()
    .then(() => {
      //this.router.navigate(['/'])
      console.log('logged out')
    });
 }

  //// Helpers ////
  private updateUserData(authData): void {
  // Writes user name and email to realtime db
  // useful if your app displays information about users or for admin features
    const path = `users/${this.currentUserId}`; // Endpoint on firebase
    const data = new User(authData)
    //console.log('UPDATE USER ds AUTh',authData)
    const ref = this.db.object(path , { preserveSnapshot: true })
    ref.take(1)
       .subscribe(user => {
         if(! user.exists()) {
          ref.update(data);
         }
    })
  }

}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/services/auth.service.ts